// extracted by mini-css-extract-plugin
export var anchorDestination = "blog-typography-module--anchorDestination--62dce";
export var blogHeadingL = "blog-typography-module--blogHeadingL--8d7e9";
export var blogHeadingM = "blog-typography-module--blogHeadingM--d0575";
export var blogHeadingXl = "blog-typography-module--blogHeadingXl--2616c";
export var blogText = "blog-typography-module--blogText--2d11b";
export var body = "blog-typography-module--body--839fc";
export var bodySmall = "blog-typography-module--bodySmall--23b42";
export var headingL = "blog-typography-module--headingL--fe1df";
export var headingM = "blog-typography-module--headingM--c70af";
export var headingXl = "blog-typography-module--headingXl--d5375";